import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(theme => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120
	},
	selectEmpty: {
		marginTop: theme.spacing(2)
	}
}));

export default function SimpleSelect(props) {
	const classes = useStyles();
	const [age, setAge] = React.useState(props.type);

	const inputLabel = React.useRef(null);
	const [labelWidth, setLabelWidth] = React.useState(0);
	React.useEffect(() => {
		setLabelWidth(inputLabel.current.offsetWidth);
	}, []);

	const handleChange = event => {
		setAge(event.target.value);
	};

	return (
		<div>
			<FormControl
				variant="outlined"
				className={classes.formControl}
				style={{ width: "100%", margin: 0 }}
			>
				<InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
					Select
				</InputLabel>
				<Select
					labelId="demo-simple-select-outlined-label"
					id="demo-simple-select-outlined"
					value={age}
					onChange={handleChange}
					labelWidth={labelWidth}
				>
					<MenuItem value={"marketing"}>Marketing</MenuItem>
					<MenuItem value={"tech"}>Tech</MenuItem>
					<MenuItem value={"support"}>Support</MenuItem>
					<MenuItem value={"lab"}>Lab</MenuItem>
				</Select>
			</FormControl>
		</div>
	);
}
